import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpErrorResponseInterceptor implements HttpInterceptor {

  private uri = environment.url;

  constructor(private _toastr: ToastrService, private _router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError<any, any>((error: HttpErrorResponse) => {
        const status = error.status;
        console.error(error);

        if (status == 0) {
          this._toastr.error('Connection error', 'Failed');
        }
        else if (status == 401) {
          if (request.url !== `${this.uri}/authenticate`) {
            this._toastr.error('Session expired', 'Failed');
            this._router.navigate(['/signin']);
          } else {
            this._toastr.error(error.error.error_description);
          }
        }
        else if (status == 500) {
          // this._toastr.error("Something happened, please try again later!", 'Failed');
        }

        return throwError(error);
      })
    );
  }
}
